module.exports = __webpack_public_path__ + "static/media/product5.0d07da79.png";